import React from 'react';
import { VirtualTerminal } from 'components';

function VirtualTerminalComponent(props) {
    return <VirtualTerminal {...props} />;
}

export default VirtualTerminalComponent;
